<template>

  <div id="messages-filter">
    <br/>
    <br/>
    <f7-list>
      <!-- Sélection des valeurs de Filtre -->
      <f7-list-item :class="{'filter-item-section':true}">
        <!-- showLargeScreenOnly -->
        <b-row style="min-width: 100%">
          <b-col xl="2" cols="6" class="filter-item mb-3" v-if="showFilterMsgId()">
            <span class="filter-item-title">{{ $t('filter.msgId') }}</span>
            <span class="filter-item-content">
              <input v-model="msgId"
                type="text"
                :class="{'filter-item-input': true, 'filter-item-input-complete': msgId}"
                :placeholder="$t('filter.msgId_placeholder')">
              </input>
            </span>
          </b-col>
          <b-col xl="2" cols="6" class="filter-item mb-3" v-if="showFilterFileName()">
            <span class="filter-item-title">{{ $t('filter.msgId') }}</span>
            <span class="filter-item-content">
              <input v-model="requestIdentifier"
                type="text"
                :class="{'filter-item-input': true, 'filter-item-input-complete': requestIdentifier}"
                :placeholder="$t('filter.msgId_placeholder')">
              </input>
            </span>
          </b-col>

          <b-col xl="2" cols="6" class="filter-item mb-3" v-if="showFilterStatusGlobal()">
            <span class="filter-item-title" style="margin-left: 2px">
              {{ $t('pain008.stat_global_imported_file') }}
            </span>
            <span class="filter-item-content d-flex">
              <select id="sel2"
              v-model="status"
              style="cursor: pointer; font-size: 13px; height: auto; z-index: 2; color: #969696">
                <option value="">{{ $t('acceptance.select_stat') }}</option>
                <option v-for="status in statusL" :key="status.code" :value="status.code">
                  {{ status.label }}
                </option>
              </select>
              <i class="fa-light fa-chevron-down" size="17px" id="status-chevron"
                style="cursor: pointer; margin-left: -20px; z-index: 1">
              </i>
            </span>
          </b-col>

            <b-col xl="2" cols="5" class="filter-item mb-3" v-if="showFilterDateBegin()">
              <span class="filter-item-title">
                {{ $t('common.date_start_label') }}</span>
              <span class="filter-item-content">
                <input v-model="dateBegin"
                  type="date"
                  :class="{'cursor filter-item-input': true, 'cursor filter-item-input-complete': dateBegin}"
                  :placeholder="$t('common.slct_date')">
                </input>
              </span>
            </b-col>

            <b-col xl="2" cols="5" class="filter-item mb-3" v-if="showFilterDateEnd()">
              <span class="filter-item-title">
                {{ $t('common.date_end_label') }}
              </span>
              <span class="filter-item-content">
                <input v-model="dateEnd"
                  type="date"
                  :class="{'cursor filter-item-input': true, 'cursor filter-item-input-complete': dateEnd}"
                  :placeholder="$t('common.slct_date')">
                </input>
                <div v-if="isEndDateInvalid" class="error-message text-danger">{{ $t('common.error_end_date_invalid') }}</div>
              </span>
            </b-col>

          <!-- Bouton Effacer et Appliquer -->
          <b-col xl="1" cols="6" class="mt-3 mr-3 text-right">
            <b-button class="btn" size="sm"
            @click="clearFilterFields"
            :disabled="!hasInputFilter"
            style="width: 80px; height: 28px">
            <i class="fa-solid fa-xmark"></i>
            <!-- {{ $t('filter.clr_fltr_field') }} -->
            </b-button>
          </b-col>
          <b-col xl="1" cols="6" class="mt-3 text-left">
            <b-button class="btn btnApplyFilter" size="sm"
              @click="applyFilter(modeFilter)">
              <i class="fa-light fa-magnifying-glass" size="17px"></i>
            </b-button>
          </b-col>
          <b-col xl="2" class="showLargeScreenOnly mt-4 text-right">
            <b> {{countResults}} {{ $t('pain008.returned_result') }} </b>
          </b-col>
          <b-col xl="2" cols="12" class="showSmallScreenOnly mt-4 text-center">
            <b> {{countResults}} {{ $t('pain008.returned_result') }} </b>
          </b-col>
        </b-row>
      </f7-list-item>
    </f7-list>
  </div>

</template>

<script>
import datePickerMixin from "@/mixins/datePickerMixin"
import Status from "@/helpers/status.js"
import { statusLabel, statusIcon } from "@/helpers/labels.js"
import services from "@/helpers/services.js"

export default {
  mixins: [datePickerMixin],
  name: "MessagesFilter",
  props: {
    countResults: {
      type: String,
      default: false,
    },
    filterType: {
      type: String,
      default: "list",
    },
    format: {
      type: String,
      default: ''
    },
    mode: {
      type: Number,
      default: 1,
    },
    propedServiceId: {
      type: String,
      default: "none",
    },
    randomId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      CurrentNameFile: '',
      CurrentFormat: '',
      CurrentIdFormat: '',
      dateBegin: '',
      dateEnd: '',
      dir: 0,
      fileName: '',
      filterTypeGet: 'list',
      hasDefaultFilter: false,
      msgId: '',
      modeFilter: this.mode,
      randomString: '',
      requestIdentifier: '',
      services: services,
      serviceId: '',
      status: '',
      statusL: [
        {
          code: 1,
          label: statusLabel(this.$i18n, 'pacs008_1')
        },
        {
          code: 0,
          label: statusLabel(this.$i18n, 'pacs008_2')
        },
      ]
    }
  },
  created() {
    if (this.propedServiceId === "none") {
      this.serviceId = this.$engine.user.currentService.id
    } else {
      this.serviceId = this.propedServiceId
    }
    this.filterTypeGet = this.filterType

    this.$bus.on("service:change", (val) => {
      this.serviceId = this.$engine.services.getServiceIdByName(val)
    })
    this.$bus.emit("right-panel-set-feature", "filter-messages")

    // Command "apply filter" from the right-panel-filter-view (mobile)
    this.$bus.on("filter-apply-filter-" + this.randomId, (filter = {}) => {
      if (Object.keys(filter).length) {
        this.applyFilter(1, filter)
      } else {
        this.applyFilter()
      }
    })
    // Command "clear filter fields" from the right-panel-filter-view (mobile)
    this.$bus.on("filter-clear-filter-fields", () => {
      this.clearFilterFields()
    })
    // Command "save filter" from the right-panel-filter-view (mobile)
    this.$bus.on("filter-save-filter", () => {
      this.saveDefaultFilter()
    })
    // Command "delete filter" from the right-panel-filter-view (mobile)
    this.$bus.on("filter-delete-filter", () => {
      this.deleteFilter()
    })

    // Intercepts filter changes from the right-panel-filter-view (mobile)
    this.$bus.on("filter-update-fields", (filter) => {
      for (const property in filter) {
        if (this.statusList[property] !== undefined) {
          // Set filter status values
          this.statusList[property].state = filter[property]
        } else {
          // Set filter other values
          this[property] = filter[property]
        }
      }
    })
  },
  mounted() {
    this.dir = this.$settings.msgDirection
    this.randomString = Math.random()
      .toString(36)
      .replace(/[^a-z]+/g, "")
      .substr(0, 5)

    let actualService = this.getActualService()
    var defaultFilter = {}
    switch (this.filterTypeGet) {
      case "details":
        defaultFilter = actualService.filterDetails.getDefaultFilter()
        if (this.modeFilter === 2) {
          defaultFilter.statusDocRejected = 1
          defaultFilter.statusDocValidated = 1
        }
        break
      case "draft":
        defaultFilter = actualService.filterDraft.getDefaultFilter()
        break
      case "group":
        defaultFilter = actualService.filterGroup.getDefaultFilter()
        break
      case "list":
        defaultFilter = actualService.filter.getDefaultFilter()
        break
      default:
        break
    }

    // Set default filter values
    this.setDefaultFilter(defaultFilter)

    // Warns right-panel-filter-view (mobile) that default values have been applied
    this.communicateChange()
  },
  beforeDestroy() {
    // this.$bus.emit('right-panel-clear-feature', 'filter-messages')
    this.$bus.off("service:change")
    this.$bus.off("filter-update-fields")
    this.$bus.off("filter-apply-filter-" + this.randomId)
    this.$bus.off("filter-save-filter")
    this.$bus.off("filter-delete-filter")
    this.$bus.off("filter-update-fields")
  },
  computed: {
    filterFields() {
      let that = this
      let filter = {}

      // Date, Reason and Name values
      filter.dateBegin = this.dateBegin
      filter.dateEnd = this.dateEnd
      filter.status = this.status
      filter.hasDefaultFilter = this.hasDefaultFilter
      filter.fileName = this.fileName
      filter.msgId = this.msgId
      filter.CurrentNameFile = this.CurrentNameFile
      filter.CurrentFormat = this.CurrentFormat
      filter.CurrentIdFormat = this.CurrentIdFormat
      filter.requestIdentifier = this.requestIdentifier

      // Status values
      for (let property in this.statusList) {
        let status = that.statusList[property]
        filter[property] = status.state
      }

      return filter
    },
    hasInputFilter() {
      if (
        (this.statusDisplay.nb > 0 && this.modeFilter !== 2) ||
        this.dateBegin ||
        this.dateEnd ||
        (this.status || this.status === 0) ||
        this.fileName ||
        this.CurrentNameFile ||
        this.CurrentFormat ||
        this.CurrentIdFormat ||
        this.requestIdentifier ||
        this.msgId
      ) {
        return true
      }
      return false
    },
    isEndDateInvalid() {
      return !this.validateEndDate()
    },
    isSmartphoneOS() {
      return this.$f7.device.os === "android" || this.$f7.device.os === "ios"
    },
    realStatusList() {
      let that = this
      const list = []
      for (const property in that.statusList) {
        const status = that.statusList[property]
        list.push({
          tag: property,
          label: status.label,
          icon: status.icon,
          state: status.state,
        })
      }
      return list
    },
    statusDisplay() {
      let realStatusList = this.realStatusList.filter(
        (status) => status.state === 1
      )
      if (realStatusList.length === 0) {
        return {
          label: this.$t("filter.selected_status_none"),
          nb: 0,
        }
      } else if (realStatusList.length === 1) {
        return {
          label: realStatusList[0].label,
          icon: realStatusList[0].icon,
          nb: 1,
        }
      } else {
        let finalLabel
        if (realStatusList.length === this.realStatusList.length) {
          finalLabel = this.$t("pain008.select_all")
        } else {
          finalLabel = realStatusList[0].label
          for (let i = 1; i < realStatusList.length; i++) {
            finalLabel += ", " + realStatusList[i].label
          }
        }
        return {
          label: finalLabel,
          nb: realStatusList.length,
        }
      }
    }
  },
  methods: {
    applyFilter(mode = 1, filterConditions = {}) {
      let that = this

      let actualService = this.getActualService()
      let actualFilter = actualService.filter
      actualFilter.cleanFilterCondition()

      let statusSelected = []
      for (let property in this.statusList) {
        let status = that.statusList[property]
        if(status.state === 1) {
          // statusSelected.push(status.code)
          statusSelected = status.code
        }
        // actualFilter[property] = status.state
      }
      actualFilter.status = this.status //statusSelected

      actualFilter.dateBegin = this.dateBegin
      actualFilter.dateEnd = this.dateEnd ? (this.dateEnd + 'T23:59:59') : ''
      actualFilter.fileName = this.fileName
      actualFilter.msgId = this.msgId
      actualFilter.CurrentNameFile = this.CurrentNameFile
      actualFilter.CurrentFormat = this.CurrentFormat
      actualFilter.CurrentIdFormat = this.CurrentIdFormat
      actualFilter.requestIdentifier = this.requestIdentifier
      actualFilter.modeFilter = mode

      // console.log('actualfilter in index', actualFilter)
      for (let propertyCustom in filterConditions) {
        actualFilter[propertyCustom] = filterConditions[propertyCustom]
      }
      // console.log("applyFilter", actualFilter, actualFilter.getConditionObject())

      this.$emit("applyFilter", actualFilter.getConditionObject())
    },
    clearFilterFields() {
      let that = this
      for (let property in that.statusList) {
        that.statusList[property].state = 0
      }

      if (
        this.modeFilter === 2 &&
        this.serviceId === services.DOCUMENTSERVICE
      ) {
        that.statusList.statusDocRejected.state = 1
        that.statusList.statusDocValidated.state = 1
      }

      this.dateBegin = ""
      this.dateEnd = ""
      this.status = ""
      this.fileName = ""
      this.msgId = ""
      this.CurrentNameFile = ''
      this.CurrentFormat = ''
      this.CurrentIdFormat = ''
      this.requestIdentifier = ''
      this.communicateChange()
    },
    deleteFilter() {
      let actualService = this.getActualService()
      switch (this.filterTypeGet) {
        case "details":
          actualService.filterDetails.saveDefaultFilter({})
          break
        case "draft":
          actualService.filterDraft.saveDefaultFilter({})
          break
        case "group":
          actualService.filterGroup.saveDefaultFilter({})
          break
        case "list":
          actualService.filter.saveDefaultFilter({})
          break
        default:
          actualService.filter.saveDefaultFilter({})
          break
      }
      this.hasDefaultFilter = false
      this.$f7.modal({
        title: "Filtre supprimé",
        buttons: [
          {
            text: "OK",
            onClick: function () {
              return
            },
          },
        ],
      })
    },
    saveDefaultFilter() {
      let that = this

      let actualService = this.getActualService()

      let defaultFilter = {
        dateBegin: this.dateBegin,
        dateEnd: this.dateEnd,
        status: this.status,
        fileName: this.fileName,
        msgId: this.msgId
      }

      for (const property in this.statusList) {
        let status = that.statusList[property]
        defaultFilter[property] = status.state
      }

      switch (this.filterTypeGet) {
        case "details":
          actualService.filterDetails.saveDefaultFilter(defaultFilter)
          break
        case "draft":
          actualService.filterDraft.saveDefaultFilter(defaultFilter)
          break
        case "group":
          actualService.filterGroup.saveDefaultFilter(defaultFilter)
          break
        case "list":
          actualService.filter.saveDefaultFilter(defaultFilter)
          break
        default:
          actualService.filter.saveDefaultFilter(defaultFilter)
          break
      }

      if (this.hasInputFilter) {
        this.hasDefaultFilter = true
      }

      that.$f7.modal({
        title: this.$i18n.t("filter.dflt_fltr_svd"),
        buttons: [
          {
            text: "OK",
            onClick: function () {
              return
            },
          },
        ],
      })
    },
    getActualService() {
      let serviceName = {
        10: this.$engine.pacs008,
      }
      return serviceName[this.serviceId]
    },
    communicateChange() {
      this.$bus.emit("right-panel-filter-view-update-fields",this.filterFields)
    },
    setDefaultFilter(defaultFilter) {
      for (const property in defaultFilter) {
        if (this.statusList[property] !== undefined) {
          // Set filter status values
          this.statusList[property].state = defaultFilter[property]
          if (defaultFilter[property] === 1) {
            this.hasDefaultFilter = true
          }
        } else {
          // Set filter other values
          if (property !== "modeFilter") {
            this[property] = defaultFilter[property]
            if (this[property]) {
              this.hasDefaultFilter = true
            }
          }
        }
      }
    },
    showFilterDateBegin() {
      return true
    },
    showFilterDateEnd() {
      return true
    },
    showFilterFileName() {
      return this.format === 'SDD'
    },
    showFilterStatusGlobal() {
      return true
    },
    showFilterMsgId() {
      return this.format === 'SCT'
    },
    validateEndDate() {
      if (this.dateEnd && this.dateBegin && this.dateEnd < this.dateBegin) {
        return false
      }
      return true
    }
  },
  watch: {
    hasDefaultFilter() {
      this.communicateChange()
    },
    dateBegin() {
      this.communicateChange()
    },
    dateEnd() {
      this.communicateChange()
    },
    status() {
      this.communicateChange()
    },
    fileName() {
      this.communicateChange()
    },
    msgId() {
      this.communicateChange()
    },
    statusList: {
      deep: true,
      handler() {
        this.communicateChange()
      },
    },
  },
}
</script>
